import React, { useState } from "react";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";
import { Button, ModalBody, ModalFooter } from "reactstrap";
import LoginLoaderButton from "../../../../../../../Common/Loader/LoginLoaderButton";

export default function ModelJobConform({ setReview, completeJobTimes }) {
  const [loading, setLoading] = useState(false);
  return (
    <>
      <div className="add-task">
        <h6>Complete Job</h6>
        <button
          onClick={() => setReview((state) => !state)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
      </div>
      <ModalBody>
        <p>Are You Sure You Want To Complete the Job</p>
      </ModalBody>

      <div className="modal-footer" style={{ marginBottom: 10 }}>
        <button
          disabled={loading}
          onClick={() => setReview((state) => !state)}
          className="btn"
          style={{ background: "#fff", color: "black", border: "2px solid " }}
          type="submit"
        >
          Cancel
        </button>
      </div>
      <div className="modal-footer mt-3">
        <button
          disabled={loading}
          onClick={() => completeJobTimes()}
          className="btn"
          type="submit"
        >
          {loading ? <LoginLoaderButton /> : "YES"}
        </button>
      </div>
    </>
  );
}
